/* unplugin-vue-components disabled */import script from "./SearchPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPanel.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPanel.vue?vue&type=style&index=0&id=457553ae&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457553ae"]])

export default __exports__